var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6711 6.04597C11.566 5.15102 13.017 5.15102 13.912 6.04597C14.8069 6.94092 14.8069 8.39192 13.912 9.28688C13.017 10.1818 11.566 10.1818 10.6711 9.28688C9.7761 8.39192 9.7761 6.94092 10.6711 6.04597ZM14.7958 5.16209C13.4127 3.77898 11.1703 3.77898 9.78717 5.16209C9.23984 5.70942 8.9091 6.39132 8.79495 7.10129L4.17871 13.3962L6.60368 15.8211L12.988 11.1393C13.6504 11.0071 14.2823 10.6843 14.7958 10.1708C16.1789 8.78765 16.1789 6.54519 14.7958 5.16209ZM11.0737 10.993C10.6043 10.8215 10.1638 10.5474 9.78717 10.1708C9.42805 9.81164 9.16218 9.39459 8.98955 8.94969L5.82089 13.2706L6.72926 14.1789L11.0737 10.993Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.6869cc273daf67c7ac26f29835829fbd.svg";
export { ForwardRef as ReactComponent };